import React, { useState, useEffect,useContext} from 'react';
import { useNavigate,useParams} from 'react-router-dom';
import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import Button from '../../../Components/Button';
import InputSelect from '../../../Components/InputSelect';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';

import { GlobalContext } from '../../../GlobalContext';

const EditAgent = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Modify agent information');
    });
    const { agentId } = useParams();
    const token = localStorage.getItem('token');
    const decodedToken = jwtDecode(token);
    const userId ={userID: decodedToken.id};

    const countryNames = [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Anguilla",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Ascension",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda Is",
        "Bolivia",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burma",
        "Burundi",
        "Cameroon",
        "Canada",
        "Cayman Is",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Congo",
        "Cook Is",
        "Costa Rica",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica Rep",
        "Ecuador",
        "Egypt",
        "EI Salvador",
        "Estonia",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hongkong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Ivory Coast",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kampuchea (Cambodia)",
        "Kazakstan",
        "Kenya",
        "Korea",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mariana Is",
        "Martinique",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montserrat Is",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netheriands Antilles",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "Norway",
        "Oman",
        "Pakistan",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Reunion",
        "Romania",
        "Russia",
        "Saint Lucia",
        "Saint Vincent",
        "Samoa Eastern",
        "Samoa Western",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Is",
        "Somalia",
        "South Africa",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States of America",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Yugoslavia",
        "Zimbabwe",
        "Zaire",
        "Zambia",
        "Montenegro "
    ];

    //---------Reset password---------------
    const [resetPasswordOpen, setResetPasswordOpen] = useState(false);

    const [userAgentData, setUserAgentData] = useState({});
    const [userPassword, setUserPassword] = useState({token:token});
    useEffect(() => {
        const fetch = async () => {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            await axios.post(`${POCBaseUrl}/agents/getone`, {agentId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response => {
                console.log('response',response.data, response.data.data.name);
                setUserAgentData(response.data.data);
            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
        }
        fetch();
    }, []);

    const handleProfileChange = (e) => {
        setUserAgentData({
            ...userAgentData,
            [e.target.name]: e.target.value,
        });
    };

    const handlePasswordChange = (e) => {
        setUserPassword({
            ...userPassword,
            [e.target.name]: e.target.value,
        });
    };

    const handleDataFromChild = (data) => {
        setUserAgentData({
            ...userAgentData,
            ['area']: data,
        });
    };

    const [resetPasswordOk, setResetPasswordOk] = useState(false);

    const handleAgentUpdate = async(e) => {
        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if(!resetPasswordOk) {
                setUserPassword({});
            }

            const response = await axios.post(`${POCBaseUrl}/agents/edit`, {agentId,userAgentData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                console.log(response.data.message);
                toast.success("Updated successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    const handleResetPassword = async(e) => {

        setResetPasswordOpen(false);
        setResetPasswordOk(true);

        e.preventDefault();
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }
            if(!resetPasswordOk) {
                setUserPassword({});
            }

            const response = await axios.post(`${POCBaseUrl}/agents/resetpassword`, {agentId,userPassword},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Authorization: `Bearer ${token}`, // Include the token
                    },
                  }
            )
            .then(response=>{
                console.log(response.data.message);
            })
            .catch(error=>{
                console.error("There was an error", error);
            })
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    const gotoAgentList = () => {
        navigate(`/agentlist`); // Use navigate for routing
    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]">
                <div className="ml-[25px] mt-2.5 pr-[40px] border-r border-white">
                    <div className='mb-[22px] flex'>
                        <Label text={'Name'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'name'} value={userAgentData.name || ''} onChange={handleProfileChange} placeholder={'Alertline Security'} className={'cursor-not-allowed'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Contacts'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'contacts'} value={userAgentData.contacts || ''} onChange={handleProfileChange} placeholder={''} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-10 numbers, letters, underlines, but not starts with underline</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Area'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputSelect name={'area'} value={userAgentData.area || ''} onSendData={handleDataFromChild}  options={countryNames} className={'cursor-pointer'} inputwidth={360}/>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select area</span>
                    </div>
                    {/* <div className='mb-[22px] flex'>
                        <Label text={'PTT card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'ptt_card'} value={userAgentData.ptt_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Recording card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'recording_card'} value={userAgentData.recording_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'GPS card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'gps_card'} value={userAgentData.gps_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'SOS card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'sos_card'} value={userAgentData.sos_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Bounding card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'bounding_card'} value={userAgentData.bounding_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Duplex card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'duplex_card'} value={userAgentData.duplex_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'VIP card'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'vip_card'} value={userAgentData.vip_card || ''} placeholder={'0'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div> */}
                    <div className='mb-[22px] flex'>
                        <Label text={'Account'} />
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'account'} value={userAgentData.account || ''} placeholder={'Alertline123'} className={'cursor-not-allowed !text-[#5a5655]'} disabled={true}/>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Login password'} />
                        <div className='relative text-[14px] leading-[40px] !w-[272px]'>
                            <InputField type={'password'} placeholder={'******'} className='!w-[272px]' />
                        </div>
                        <div>
                            <Button children={'Reset'} onClick={()=> setResetPasswordOpen(true)}/>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Constains 6-16 letters or numbers</span>
                    </div>
                </div>
            </div>
            <div className='flex mt-2.5 bg-[#f0f0f0]' style={{ fontFamily: 'Liberation Serif' }}>
                <button onClick={handleAgentUpdate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Update
                </button>
                <button onClick={gotoAgentList} className='inline-block mt-2.5 mb-2.5 ml-3 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Return to the list
                </button>
            </div>
            {resetPasswordOpen && (
                <div className="fixed inset-0 p-4 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-6 relative">
                        <div className="flex items-center pb-3 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Reset login password</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={()=> setResetPasswordOpen(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>
        
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655]'>New password:</span>
                            <InputField name = {'newPassword'} value={userPassword.newPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please enter the new password (6-16 characters)'} />
                        </div>
                        <div className="pt-5 flex justify-center items-center">
                            <span className='text-[#5a5655]'>Confirm password:</span>
                            <InputField name = {'confirmPassword'} value={userPassword.confirmPassword || ''} onChange={handlePasswordChange} type={'password'} placeholder={'Please confirm the new password (6-16 characters)'} />
                        </div>
        
                        <div className="pt-10 flex justify-center gap-4" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[320px] h-[36px] rounded-lg text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                                onClick={handleResetPassword} // Close modal on click
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default EditAgent;